import AbstractController from '../../../Controller/AbstractController';
import Controller from '../../../Controller/Controller';
import HeaderSlider from '../Elements/HeaderSlider';

/**
 * Header Slider Controller
 *
 * @class
 */
class HeaderSliderController extends AbstractController {
  /**
   * @constructor
   */
  constructor() {
    super();

    Controller.registerController(this);
    this._registerElements(HeaderSlider);
  }
}

export default new HeaderSliderController();
